module.exports = __webpack_public_path__ + "static/img/gu.4cd5e319.svg";